module.exports = __webpack_public_path__ + "img/ticino02.712145cb.jpg";